import src from "IMAGE";
export default { src, width: 165, height: 75, blurWidth: 0, blurHeight: 0};
